export const isFacebookIOSInAppBrowser = (): boolean => {
	if (typeof navigator === "undefined" || !navigator.userAgent) {
		return false;
	}

	const ua = navigator.userAgent;
	const isIOS = /iPhone|iPad|iPod/i.test(ua);
	const isFacebookInApp = /FBAN|FBAV|FB_IAB|FBIOS/i.test(ua);

	return isIOS && isFacebookInApp;
};

export default isFacebookIOSInAppBrowser;
